import React, { useEffect, useState } from "react";
import { GoArrowUp } from "react-icons/go";

export const BottomButton = ({ buttonStyle, id }) => {
  const [showTopBtn, setShowTopBtn] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 200) {
        setShowTopBtn(true);
      } else {
        setShowTopBtn(false);
      }
    });
  }, []);
  const goToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <div className="relative">
        {showTopBtn && (
          <span
            id={id}
            style={buttonStyle}
            onClick={goToTop}
            className="icon-style bg-[#A5302E]  flex justify-center items-center stroke-1 stroke-white rounded-[50%] 
          h-[50px] w-[50px] fixed bottom-10 right-6 lg:bottom-20 lg:right-12 z-50 cursor-pointer
          animate-bounce transition-all ease-in-out"
          >
            <GoArrowUp
              style={{ color: buttonStyle.Color }}
              className="text-2xl font-bold"
            />
          </span>
        )}
      </div>
    </>
  );
};

export default BottomButton;
